import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Input, Table } from "reactstrap";

import { confirm } from "components/Confirmation";

import IconButton from "components/IconButton";
import modeloComponenteService from "services/ModeloComponenteService";
import comboService from "services/ComboService";

export default function Filhos({ edit, idModeloComponente, onChange }) {
  const [items, setItems] = useState([])
  const [alteracao, setAlteracao] = useState(false)
  const [tiposComponente, setTiposComponente] = useState([])
  const [slot, setSlot] = useState()

  useEffect(() => {
    comboService.tipoComponente().then(res => {
      if (res.success) {
        setTiposComponente(res.data)
      }
    })
  }, [])

  useEffect(() => {
    if (!edit) {
      setSlot(null)
      setAlteracao(false)
    }
  }, [edit])

  const carregar = async () => {
    const res = await modeloComponenteService.listarFilhoLimite(idModeloComponente)
    if (res.success) {
      setItems(res.data)
    }
  }

  useEffect(() => {
    if (!idModeloComponente)
      return
    carregar()
  }, [idModeloComponente])

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!slot || !slot.idTipoComponenteFilho) return

    const reg = tiposComponente.find(el => el.id == slot.idTipoComponenteFilho)
    if (!reg) return

    const quantidadeMaxima = parseInt(slot.quantidadeMaxima)
    if (!quantidadeMaxima || quantidadeMaxima <= 0) return

    try {
      let res = null
      if (alteracao) {
        res = await modeloComponenteService.updateFilhoLimite(idModeloComponente, slot.id, {
          quantidadeMaxima,
        })
      } else {
        res = await modeloComponenteService.createFilhoLimite(idModeloComponente, {
          idTipoComponenteFilho: reg.id,
          quantidadeMaxima,
        })
      }

      if (res.success) {
        carregar()
        onChange && onChange()
        toast("O registro foi salvo com sucesso")
      } else {
        toast("Erro ao salvar o registro")
      }
    } catch (ex) {
      toast("Erro ao salvar o registro")
    }

    setSlot(null)
    setAlteracao(false)
  }

  const handleDelete = (item) => {
    confirm({
      header: "Exclusão",
      text: "Tem certeza que gostaria de continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          const res = await modeloComponenteService.deleteFilhoLimite(idModeloComponente, item.id)
          if (res.success) {
            carregar()
            onChange && onChange()
            toast("O registro foi excluído com sucesso")
          } else {
            toast("Erro ao excluir o registro")
          }
        } catch (ex) {
          toast("Erro ao excluir o registro")
        }
      }
    })
  }

  const handleEdit = (item) => {
    setSlot({ id: item.id, idTipoComponenteFilho: item.idTipoComponenteFilho, quantidadeMaxima: item.quantidadeMaxima })
    setAlteracao(true)
  }

  const handleCancelEdit = () => {
    setSlot(null)
    setAlteracao(false)
  }

  const handleTipo = (e) => {
    const _slot = slot || {}
    _slot.idTipoComponenteFilho = e.target.value
    _slot.quantidadeMaxima = _slot.quantidadeMaxima || 1
    setSlot({ ..._slot })
  }

  const handleQuantidade = (e) => {
    const _slot = slot || {}
    _slot.idTipoComponenteFilho = _slot.idTipoComponenteFilho || ''
    _slot.quantidadeMaxima = e.target.value
    setSlot({ ..._slot })
  }

  return (
    <>
      <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th scope="col">Tipo de Componente Filho</th>
            <th scope="col">Quantidade Máxima</th>
            {edit && (
              <th scope="col" style={{ width: 120 }}></th>
            )}
          </tr>
        </thead>
        <tbody>
          {items.length == 0 && (
            <tr>
              <td colSpan={3} className="text-center">Nenhum registro</td>
            </tr>
          )}
          {items.map(el => (
            <tr key={el.id}>
              <td>{el.tipoComponenteFilho?.descricao}</td>
              <td>{el.quantidadeMaxima}</td>
              {edit && (
                <td className="d-flex flex-row gap-5px">
                  <IconButton alt="Editar" iconClass="bi-pencil-square" onClick={() => handleEdit(el)} />
                  <IconButton alt="Excluir" iconClass="bi-trash" onClick={() => handleDelete(el)} />
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>

      {edit && (
        <Card>
          <CardBody>
            <h2>Adicionar Slot</h2>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-5 field">
                  <label htmlFor="idTipoComponenteFilho">Tipo de Componente Filho</label>
                  <select
                    id="idTipoComponenteFilho"
                    className="form-control"
                    value={slot?.idTipoComponenteFilho || ''}
                    onChange={handleTipo}
                    disabled={alteracao}
                  >
                    <option value="">Selecione</option>
                    {tiposComponente
                      .filter(el => {
                        if (alteracao)
                          return el.id == slot.idTipoComponenteFilho // se for alteração trazer apenas o tipo que está sendo alterado
                        return !items.some(p => p.idTipoComponenteFilho == el.id) // caso contrário trazer todos que não estão na lista
                      })
                      .map(el => (
                        <option key={el.id} value={el.id}>{el.descricao}</option>
                      ))}
                  </select>
                </div>
                <div className="col-3 field">
                  <label htmlFor="quantidadeMaxima">Quantidade Máxima</label>
                  <Input
                    id="quantidadeMaxima"
                    type="number"
                    min={1}
                    step={1}
                    value={slot?.quantidadeMaxima ?? ''}
                    onChange={handleQuantidade}
                  />
                </div>

                <div className="col-4 field" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-start' }}>
                  {alteracao ? (
                    <>
                      <Button color="primary" type="submit" disabled={!slot}>Alterar</Button>
                      <Button color="danger" outline className="ml-2" onClick={handleCancelEdit}>Cancelar edição</Button>
                    </>
                  ) : (
                    <Button color="primary" type="submit" disabled={!slot}>Adicionar</Button>
                  )}
                </div>
              </div>
            </form>
          </CardBody>
        </Card>
      )}
    </>
  )
}
